import fetcher, { STATUS_OK } from "../../libs/fetcher";
import { IProject, IProjectIndexParams, IProjectIndexResponse } from "../../models/Project";

export const indexProjects = async ({ package_id }: IProjectIndexParams): Promise<IProjectIndexResponse> => {
    const url = `/packages/${package_id}/projects`;
    let response: IProjectIndexResponse = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET'
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;
        
        // console.log("🚀 ~ indexProjects ~ fetch:", fetch)
        
        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData: IProject[] = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData)) {
                    response.data = responseData;
                    response.error = false;
                    response.totalItems = responseData.length;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}